export default __webpack_public_path__ + "static/media/ASSET_03@2x.65a3111a.png";